import { z } from 'zod';

/**
 * Papéis do painel. A ordem importa: `nivel` compara quem enxerga o quê
 * (LEITOR só lê, OPERADOR comanda sessões e arquivos, ADMIN administra).
 */
export const PapelSchema = z.enum(['ADMIN', 'OPERADOR', 'LEITOR']);
export type Papel = z.infer<typeof PapelSchema>;

export const NIVEL_PAPEL: Record<Papel, number> = { LEITOR: 1, OPERADOR: 2, ADMIN: 3 };

export function papelAlcanca(papel: Papel, minimo: Papel): boolean {
  return NIVEL_PAPEL[papel] >= NIVEL_PAPEL[minimo];
}
